module.exports = __webpack_public_path__ + "static/fonts/Nunito-Regular.30d0795.woff2";